import { render, staticRenderFns } from "./dashboard-sage-femme.html?vue&type=template&id=f6487fa4&scoped=true&external"
import script from "./dashboard-sage-femme.js?vue&type=script&lang=js&external"
export * from "./dashboard-sage-femme.js?vue&type=script&lang=js&external"
import style0 from "./dashboard-sage-femme.scss?vue&type=style&index=0&id=f6487fa4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6487fa4",
  null
  
)

export default component.exports